/**
 * API Service for communicating with the backend
 */

import axios from 'axios';
import {
  FormData,
  StateInfo,
  PricingInfo,
  StripeSessionResponse,
  SubmitResponse,
  ResultsResponse,
} from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Calculator API
export const calculatorAPI = {
  /**
   * Get supported states
   */
  getStates: async (): Promise<StateInfo[]> => {
    const response = await api.get<StateInfo[]>('/calculator/states');
    return response.data;
  },

  /**
   * Get pricing information
   */
  getPricing: async (): Promise<PricingInfo> => {
    const response = await api.get<PricingInfo>('/calculator/pricing');
    return response.data;
  },

  /**
   * Submit form data and get session ID
   */
  submit: async (state: string, formData: FormData): Promise<SubmitResponse> => {
    const response = await api.post<SubmitResponse>('/calculator/submit', {
      state,
      formData,
    });
    return response.data;
  },

  /**
   * Get calculation results (after payment)
   */
  getResults: async (sessionId: string): Promise<ResultsResponse> => {
    const response = await api.get<ResultsResponse>(`/calculator/results/${sessionId}`);
    return response.data;
  },
};

// Stripe API
export const stripeAPI = {
  /**
   * Create Stripe checkout session
   */
  createCheckoutSession: async (formData: FormData, sessionId: string): Promise<StripeSessionResponse> => {
    const response = await api.post<StripeSessionResponse>('/stripe/create-checkout-session', {
      formData,
      sessionId,
    });
    return response.data;
  },

  /**
   * Get session status
   */
  getSessionStatus: async (sessionId: string): Promise<any> => {
    const response = await api.get(`/stripe/session/${sessionId}`);
    return response.data;
  },
};

// Health check
export const healthCheck = async (): Promise<{ status: string; timestamp: string }> => {
  const response = await api.get('/health');
  return response.data;
};

export default api;